import Button from "atoms/buttons/button";
import React from "react";
import TitleField from "molecules/page-and-notebook-meta/title-field";
import Icon from "atoms/icons/icon";
import { Icons } from "atoms/constants/icons";
import { t } from "utilities/localization-utils";
import useCurrentNotebook from "utilities/hooks/domain/notebooks/use-current-notebook";
import useNotebookActionPermission, {
    NotebookAction,
} from "pages/notebooks/use-notebook-action-permissions";
import { ButtonStyles } from "atoms/constants/button-styles";

interface NotebookPageHeadingProps {
    onCreatePageClick: () => void;
    onSharePageClick: () => void;
}

const CSS_CLASS_NAME = "c-notebook-page-heading";

const NotebookPageHeading: React.FC<NotebookPageHeadingProps> = (props) => {
    const { onCreatePageClick, onSharePageClick } = props;
    const { currentNotebook, rename: renameNotebook } = useCurrentNotebook();
    const { can } = useNotebookActionPermission(currentNotebook);

    return (
        <div className={CSS_CLASS_NAME}>
            <header className={`${CSS_CLASS_NAME}__header`}>
                <TitleField
                    editable={can(NotebookAction.Rename)}
                    name={currentNotebook?.name}
                    onSave={renameNotebook}
                    resourceName="notebook"
                />
            </header>

            <div className={`${CSS_CLASS_NAME}__button-group`}>
                {can(NotebookAction.Share) && (
                    <Button
                        style={ButtonStyles.Secondary}
                        onClick={onSharePageClick}>
                        {t("share")}
                    </Button>
                )}
                {can(NotebookAction.CreatePage) && (
                    <Button
                        dataTestId="notebook-page--heading--create-page-button"
                        cssClassName={`${CSS_CLASS_NAME}__button`}
                        onClick={onCreatePageClick}>
                        <Icon type={Icons.Plus} />
                        {t("create")}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default NotebookPageHeading;
